<template>
  <el-container>
    <el-aside width="200px">
      <Menu />
    </el-aside>
    <el-container>
      <el-header>
        <!-- <span>{{getTitle}}</span> -->
        <span>农产品销售（小程序）管理系统</span>
        <!-- <div class="out">
          <span @click="LogOut">退出登录</span>
        </div> -->
        <el-dropdown @command="handleCommand">
          <span class="user">
            <el-avatar :size="36" :src="circleUrl"></el-avatar>
            {{userInfo.username}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">修改密码</el-dropdown-item>
            <el-dropdown-item command="2">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main>
        <keep-alive :include="keepAlive">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
    <ChangePassword ref="ChangePassword"/>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import ChangePassword from '../ChangePassword/ChangePassword.vue';
// import HeaderAdmin from '../header/HeaderAdmin'
import Menu from '../menulist/Menu'
// import TagList from '../taglist/TagList'

export default {
  components: { Menu,ChangePassword },
  data() {
    return {
      circleUrl: "",
    };
  },
  computed: {
    ...mapState({
      isCollapse: state => state.isCollapse,
      userInfo: state => state.userInfo
    }),
    getTitle() {
      return this.$store.getters.PAGETITLE
    },
    keepAlive() {
      return this.$store.getters.keepAlive
    }
  },
  methods: {
    handleCommand(command) {
      if (command == 1) {
        this.$refs.ChangePassword.init();
        console.log(command);
      } else if (command == 2) {
        this.LogOut()
      }
    },
    LogOut() {
      this.$user.logout().then(({ data }) => {
        if (data.code === 200) {
          this.$message({
            message: data.message,
            type: 'success',
            duration: 1000,
            onClose: () => {
              sessionStorage.removeItem('token')
              this.$router.push({ path: '/' })
            }
          })
        } else {
          this.$message.error(data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  height: 100vh;
  background-color: #ffffff;
}
.el-header {
  height: 56px !important;
  background: #f5f7f9;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-main {
  background: #f5f7f9;
}
.taglist {
  position: sticky;
  top: 0px;
  z-index: 999;
  background: #f5f7f9;
}
.user {
  padding-right: 20px;
  display: flex;
  align-items: center;
  .el-avatar {
    margin-right: 16px;
  }
}
</style>